import { orderTabs } from './order-extensions';

export class SidebarTab {
  static profileTabTitle = $localize`個人資訊`;
  static addressTabTitle = $localize`我的地址`;
  static receiptTabTitle = $localize`發票設定`;
  static storeAddressSubTitle = $localize`超商取貨門市`;
  static homeAddressSubTitle = $localize`宅配收貨地址`;
  static overseaAddressSubTitle = $localize`海外收貨地址`;
  static favTabTitle = $localize`我的收藏`;
  static reminderTabTitle = $localize`貨到通知`;
  static accountStateTabTitle = $localize`帳戶現況`;
  static applySettlementTabTitle = $localize`申請結清`;
  static settlementRecordTabTitle = $localize`結清紀錄`;
  static appliedTabTitle = $localize`已申請`;
  static creditedTabTitle = $localize`已入帳`;
  static cancelOrFailTabTitle = $localize`取消/失敗`;
  static orders = orderTabs.map(i => new SidebarTab(i));
  static settlementRecordSubTabs = [
    SidebarTab.appliedTabTitle,
    SidebarTab.creditedTabTitle,
    SidebarTab.cancelOrFailTabTitle,
  ];
  static refundAccounts = [
    new SidebarTab(SidebarTab.accountStateTabTitle),
    new SidebarTab(SidebarTab.applySettlementTabTitle),
    new SidebarTab(SidebarTab.settlementRecordTabTitle, this.settlementRecordSubTabs),
  ];
  static favorite = [new SidebarTab(SidebarTab.favTabTitle), new SidebarTab(SidebarTab.reminderTabTitle)];
  static notification = [
    new SidebarTab($localize`優惠活動`),
    new SidebarTab($localize`交易訊息`),
    new SidebarTab($localize`客服中心`),
    new SidebarTab($localize`商品訊息`),
  ];
  static profile: SidebarTab[] = [
    new SidebarTab(SidebarTab.profileTabTitle),
    new SidebarTab(SidebarTab.addressTabTitle, [
      SidebarTab.storeAddressSubTitle,
      SidebarTab.homeAddressSubTitle,
      SidebarTab.overseaAddressSubTitle,
    ]),
    new SidebarTab(SidebarTab.receiptTabTitle),
  ];

  constructor(
    public tab: string,
    public subs: string[] = []
  ) {}
}
